import 'whatwg-fetch';
import validateOIDCSettings from './validateOIDCSettings.js';

const oidcSettings = function(settings) {
    validateOIDCSettings(settings);
    // check the localstorage for the presence of config for the authority
    // if the config is present in the localstorage then return the config
    // in the localstorage else make an ajax call and fetch the config
    const oidcConfigUrl = settings.authority +'/.well-known/openid-configuration';
    const config = getConfigFromStorage();
    return config ?
        Promise.resolve(config):
        getOIDCConfig(oidcConfigUrl)
            .then((config)=>{
                return setOIDCSettingsObj(settings, config);
            });
};

const getConfigFromStorage = function() {
    try {
        const config = localStorage.getItem(settings.openid_configuration);
        return JSON.parse(config);
    }
    catch (e) {
        return false;
    }
};

const getOIDCConfig = function(oidcConfigUrl) {
    return fetch(oidcConfigUrl, {
        method: 'GET',
        mode: 'cors'
    }).then((res)=>{
        try {                   
            return res.json();            
            
        }
        catch (err) {
            throw 'authorize service is down.';
        }
    });
};

const setOIDCSettingsObj = function(settings, config) {
    // settings are static settings set in the project (cleint specific)
    // config object consists of the configurations returned by the config object
    const oidcSettings = {
        clientId: settings.clientId,
        redirectUri: settings.redirectUri,
        authorizationUri: config.authorization_endpoint,
        scopes: settings.scopes,
        iss: config.issuer,
        aud: settings. clientId,
        user_type: settings.user_type,
        realm_id: settings.realm_id,
        nonce: settings.nonce,
        endSessionEndpoint: config.end_session_endpoint,
        postLogoutRedirectUri: settings.postLogoutRedirectUri,
        jwkUri: config.jwks_uri,
        token_endpoint:config.token_endpoint,
    };
    // store the settings in the html5 local storage
    // to be retieved directly from local storage the next time
    localStorage.setItem(settings.openid_configuration, JSON.stringify(oidcSettings));
    return Promise.resolve(oidcSettings);
};

export default oidcSettings;